module.exports = __webpack_public_path__ + "media/src/images/social-in-a407b49bb6b5d732b9260a0741097cf6.svg";